const tenderData = [
  {
    title: "Current Tender Opportunities",
    description: `
      At present, there are no active tenders available.
    `,
  },
];

export default tenderData;
